module.exports = __webpack_public_path__ + "media/images/talent/point-02-3bb444f0332d98df4804804ae43e09ba.png";